export enum DischargeLocationEnum {
  Home = 1,
  Facility = 2,
  Other = 3
}

export const DischargeLocationOptions = [
{ id: 1, label: 'Home' },
{ id: 2, label: 'Facility' },
{ id: 3, label: 'Other' }
];
